import React, { Fragment, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { navtoggle } from "../../store/actions/AuthActions";
import { useDispatch , useSelector} from "react-redux";
import Logo from "../../assets/images/logo.png";

const NavHader = () => {
  	const dispatch = useDispatch();
   	const sideMenu = useSelector(state => state.sideMenu);
  	const handleToogle = () => {
     	dispatch(navtoggle());
   	};
  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
	  <Fragment>
		<img
		src={Logo}
		alt="Logo"
		className="logo"
		style={{ width: '100px', height: 'auto', marginLeft: '37px' }}
		/>

		</Fragment>
      </Link>

      <div
        className="nav-control"
		onClick={() => {              
			handleToogle()
		}}
      >
        <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
